module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/isolated-profile-update/isolated-profile-update.component.css
// module id = ./src/app/Screens/isolated-profile-update/isolated-profile-update.component.css
// module chunks = main